export type ResponseError = { [key: string]: string | ResponseError };

export const covertErrors = ({
  prefix,
  errors,
}: {
  prefix?: string;
  errors: ResponseError;
}): { key: string; message: string }[] => {
  let result: { key: string; message: string }[] = [];

  for (const key in errors) {
    let errorKey = key;

    if (prefix) {
      errorKey = `${prefix}.${key}`;
    }

    const value = errors[key];

    if (typeof value === "string") {
      result.push({ key: errorKey, message: value });
      continue;
    }

    result = result.concat(covertErrors({ prefix: errorKey, errors: value }));
  }

  return result;
};
